/**
 * ConfirmationModal - Modal de confirmação reutilizável.
 * 
 * Usado para confirmar ações destrutivas (deletar, excluir, etc).
 * 
 * Princípios aplicados:
 * - Componentização: Usa Modal base do design system
 * - Single Responsibility: Apenas confirmar ações
 */
import React from 'react';
import Modal from '../ui/Modal';
import { Button } from '../ui/Button';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmButtonText?: string;
    confirmButtonColor?: 'red' | 'blue';
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmButtonText = 'Confirmar',
    confirmButtonColor = 'red',
}) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm">
            <Modal.Header onClose={onClose}>{title}</Modal.Header>
            <Modal.Body>
                <p className="text-secondary">{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="secondary" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    type="button"
                    onClick={onConfirm}
                    variant={confirmButtonColor === 'red' ? 'danger' : 'default'}
                >
                    {confirmButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;